module.exports = __webpack_public_path__ + "static/67-2de66dfc27d1e50b7864696e228066a6.png";